export default "__VITE_ASSET__BciRk8NA__"